let lastId = 0;

export default function () {
    lastId += 1;

    return `aco_${lastId}`;
}

export const sectionKey = function () {

    const ts = String(new Date().getTime());
    let i = 0;
    let out = '';
    for (i = 0; i < ts.length; i += 2) {
        out += Number(ts.substr(i, 2)).toString(36);
    }

    return `section_${out}`;
}

export const newElementId = () => {
    lastId += 1;
    let id = new Date().getTime() + '' + lastId;
    return id.substring(id.length-10);
}
